import baseRoute from '../baseRoute';

export default `${baseRoute}/platform` as const;
